import { z } from 'zod';
import { AccessSchema } from './auth';
import { objectIdSchema } from './objectId';

export const UserPreferencesSchema = z.object({
  favoriteProperties: objectIdSchema.array(),
});

export const UserSchema = z.object({
  _id: objectIdSchema,
  firstName: z.string(),
  lastName: z.string(),
  email: z.string(),
  username: z.string(),
  password: z.string(),
  recoveryToken: z.string().optional(),
  role: AccessSchema,
  superAdmin: z.boolean().nullable(),
  shipAdmin: z.boolean().nullable(),
  groupAdmin: z.boolean().optional(),
  groupUser: z.boolean().optional(),
  propertyAdmin: z.boolean().optional(),
  libraryAdmin: z.boolean().optional(),
  feedEditor: z.boolean().optional(),
  canvasEditor: z.boolean().optional(),
  brandAdmin: z.boolean().optional(),
  disabled: z.boolean().optional(),
  viewOnly: z.boolean().optional(),
  staffRole: objectIdSchema.nullable().optional(),
  acceptedLicenseAgreement: z.boolean().optional(),
  preferences: UserPreferencesSchema.optional(),
  groupApprovingVenues: objectIdSchema.array().optional(),
  userAdmin: z.boolean().optional(),
  sso: z.boolean().optional(),
});

export type User = z.infer<typeof UserSchema>;

export const NewUserSchema = z.object({
  firstName: z.string(),
  lastName: z.string(),
  email: z.string().email(),
  username: z.string(),
  password: z.string(),
  role: AccessSchema,
  superAdmin: z.boolean(),
  shipAdmin: z.boolean(),
  groupAdmin: z.boolean(),
  groupUser: z.boolean(),
  propertyAdmin: z.boolean(),
  libraryAdmin: z.boolean(),
  feedEditor: z.boolean(),
  canvasEditor: z.boolean(),
  brandAdmin: z.boolean(),
  disabled: z.boolean().optional(),
  viewOnly: z.boolean(),
  staffRole: z.string().optional(),
  acceptedLicenseAgreement: z.boolean().optional(),
  preferences: UserPreferencesSchema.optional(),
  groupApprovingVenues: z.string().array().optional(),
  userAdmin: z.boolean().optional(),
  sso: z.boolean().optional(),
});

export const ScrubbedUserSchema = UserSchema.omit({ password: true, recoveryToken: true });

export const UserAuthSchema = z.object({
  token: z.string(),
});
